
<section class="breadcrumb-banner">
	<div class="container">
		<div class="row">
			<div class="col-md-12 col-lg-12">
				<div class="breadcrumb-text">
					<h1>Football Tournament</h1>
				</div>
			</div>
		</div>
	</div>
	<div class="breadcrumb-bottom-img">
		<img
			src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
	</div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
	<div class="container">
		<div class="sec-title text-center">
			<h2>G.H Raisoni Memorial Cup <span> Football Tournament</span></h2>
		</div>
		<div class="row">
			<div class="col-md-12">
				<p class="text-justify">G.H Raisoni Memorial Cup presented by GH Raisoni Sports & Cultural Foundation,
					supported by Raisoni Group of Institutions, organized a flood-lit football tournament from 21st May
					2023 to 31st May 2023 on the NIT Ground in Darshan Colony, Sadbhavna Nagar. The event was conducted
					and managed by Sapt Maharshi Bahuuddeshiye Sanstha, Nagpur and Unity Football Academy. The
					tournament was an open game format 11 A side, registered under the aegis of Nagpur District Football
					Association. </p>
				<p class="text-justify">The inaugural match was between the Noble Sports Academy and DDSYS Academy. The
					tournament carries a total prize money of Rs. 1,50, 000 with the winners getting Rs. 50,000 and the
					runners-up team taking home a cash prize of Rs. 31,000. The winner in the girl's category will get
					Rs. 21,000 while the runners-up will get Rs. 11,000 apart from individual prizes.</p>
				<p class="text-justify">The sixteen participating teams include Kanojiya FC, GNFC, AL Kausar FC, Aai
					Foundation FC, Rabbani Club, Kamptee, Motibag FC, Nobel Sports Academy, Defender FC, Qidwai Sports
					(Annaji Shop), Friends United FC, Unity Football Academy, Indian Friends Football Club, Chankapur,
					South East Central Railways Sports Association (SECRSA) and DDSYS Academy. </p>
			</div>
		</div>
		<div class="border-line-sm"></div>
		<div class="row row-cols-1 row-cols-md-2">
			<div class="col">
				<div class="row">
					<div class="gall-ery">
						<div class="col-md-12">
							<div class="widget_title inner-title">
								<h4 class="fw-bold">Photos</h4>
							</div>
						</div>

						<div class="lightBox--gallery">
							<ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-1.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-1.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-1.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-2.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-2.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-2.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-3.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-3.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-3.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-4.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-4.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-4.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-5.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-5.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-5.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-6.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-6.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-6.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-7.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-7.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-7.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-8.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-8.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-8.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-9.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-9.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-9.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-10.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-10.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-10.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-11.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-11.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-11.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-12.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-12.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-12.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-13.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-13.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-13.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-14.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-14.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-14.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
								<li class="col"
									data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-15.webp"
									data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-15.webp">
									<a href="Javascript:void(0);">
										<img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/memorial/memorial-15.webp"
											alt="GHRSCF" title="GHRSCF" class="img-fluid" />
										<div class="light-gallery-poster">
											<img
												src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
										</div>
									</a>
								</li>
							</ul>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</section>
